import { useEffect, useState, useCallback } from "react";
import React from 'react';
import "./DataResult.scss";

export default function DataResult({ apiData, apiDataCaract, searchedItem, onItemSelected, onHatSelected, onAmuSelected ,onCloakSelected, onSwordSelected,onAnno2Selected,onBeltSelected,onBootsSelected, annoImage }) {

  const [dataToDisplay, setDataToDisplay] = useState([]);

  const [filters, setFilters] = useState({
    Force: {active :false},
    Intelligence: {active :false},
    Chance: {active :false},
    Agilité: {active :false},
    Puissance: {active :false},
  });

  const handleFilter = (name) => {
    setFilters(prevFilters => ({
      ...prevFilters,
      [name]: { active: !prevFilters[name].active }
    }));
  };

  const filterData = useCallback((data, filterName) => {
    if (filters[filterName].active) {
      return data.filter(
        (itemCaract) =>
          itemCaract.effects &&
          itemCaract.effects.some((effect) => effect.type.name === filterName)
      );
    }
    return data;
  }, [filters]);

  
  useEffect(() => {
    let data = [];
  
    if (searchedItem) {
      data = Array.isArray(searchedItem) ? [...searchedItem] : [searchedItem];
    } else {
      data = apiDataCaract.filter((itemCaract, index) => {
        return itemCaract && apiData[index];
      });
    }
  
    data = filterData(data, "Force");
    data = filterData(data, "Intelligence");
    data = filterData(data, "Chance");
    data = filterData(data, "Agilité");
    data = filterData(data, "Puissance");
  
    data.sort((a, b) => a.name.localeCompare(b.name, "fr"));
  
    setDataToDisplay(data);
  }, [searchedItem, filters, apiDataCaract, apiData, filterData]);
  

  const handleItemSelection = (itemCaract) => {
    if (itemCaract.type.name === "Chapeau") {
      onHatSelected(itemCaract);
    } else if (itemCaract.type.name === "Amulette") {
      onAmuSelected(itemCaract);
    } else if (itemCaract.type.name === "Cape") {
      onCloakSelected(itemCaract);
    } else if (itemCaract.type.name === "Anneau") {
      if (annoImage) {
        onAnno2Selected(itemCaract);
      } else {
        onItemSelected(itemCaract);
      }
    } else if (itemCaract.type.name === "Ceinture") {
      onBeltSelected(itemCaract);
    } else if (itemCaract.type.name === "Bottes") {
      onBootsSelected(itemCaract);
    } else if (itemCaract.type.name === "Épée") {
      onSwordSelected(itemCaract);
    }
  };
  

  return (
    <div className='data__result'>
        <div className="btn__filter__wrapper">
        <button className={`btn__filter ${filters.Force.active ? 'isActive' : ''}`} onClick={() => handleFilter('Force')}>Force</button>
        <button className={`btn__filter ${filters.Intelligence.active ? 'isActive' : ''}`} onClick={() => handleFilter('Intelligence')}>Intelligence</button>
        <button className={`btn__filter ${filters.Chance.active ? 'isActive' : ''}`} onClick={() => handleFilter('Chance')}>Chance</button>
        <button className={`btn__filter ${filters.Agilité.active ? 'isActive' : ''}`} onClick={() => handleFilter('Agilité')}>Agilité</button>
        <button className={`btn__filter ${filters.Puissance.active ? 'isActive' : ''}`} onClick={() => handleFilter('Puissance')}>Puissance</button>
      </div> 
      <div className="data__result__wrapper">
        {dataToDisplay.map((itemCaract) => (
          <div className="data__result__item" key={itemCaract.ankama_id}>
            <h4 className='item__name'>{itemCaract.name}</h4>
            <span className='item__lvl'>Lvl {itemCaract.level}</span>
            {itemCaract.image_urls && itemCaract.image_urls.hd && (
              <img src={itemCaract.image_urls.hd} alt={itemCaract.name} />
            )}
            <div className='item__content'>
              {itemCaract.effects && Array.isArray(itemCaract.effects) && (
                itemCaract.effects.map((effect, effectIndex) => (
                  <div className='item__solo' key={effectIndex}>
                    <span>{effect.formatted}</span>
                  </div>
                ))
              )}
            </div>
            <span className='selec__item' onClick={() => handleItemSelection(itemCaract)}>+</span>
          </div>
        ))}
      </div>
    </div>
  );
}  
